import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  loginAPI,
  registerAPI,
  logoutAPI,
  forgotPasswordAPI,
  resetPasswordAPI,
  verifyEmailAPI,
  updateProfileAPI,
  changePasswordAPI,
  refreshTokenAPI,
  getRoleListAPI // ✅ Added new API
} from './authAPI';

// ✅ Thunk for login
export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await loginAPI(credentials);
      console.log("API Response in thunk:", response);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to login'
      );
    }
  }
);

// ✅ Thunk for register
export const register = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await registerAPI(userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to register'
      );
    }
  }
);

// ✅ Thunk for logout
export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      const response = await logoutAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to logout'
      );
    }
  }
);

// ✅ Thunk for forgot password
export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (email, { rejectWithValue }) => {
    try {
      const response = await forgotPasswordAPI(email);
      console.log("Forgot Password API response in thunk:", response);
      return response; // ✅ fixed
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to send reset email'
      );
    }
  }
);


// ✅ Thunk for reset password
// export const resetPassword = createAsyncThunk(
//   'auth/resetPassword',
//   async (payload, { rejectWithValue }) => {
//     try {
//       const response = await resetPasswordAPI(payload);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.message || error.message || 'Failed to reset password'
//       );
//     }
//   }
// );
// ✅ Thunk for reset password - receives {payload, token}
export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ payload, token }, { rejectWithValue }) => {
    try {
      const response = await resetPasswordAPI({ payload, token });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to reset password'
      );
    }
  }
);
// ✅ Thunk for verify email
export const verifyEmail = createAsyncThunk(
  'auth/verifyEmail',
  async (token, { rejectWithValue }) => {
    try {
      const response = await verifyEmailAPI(token);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to verify email'
      );
    }
  }
);

// ✅ Thunk for update profile
export const updateProfile = createAsyncThunk(
  'auth/updateProfile',
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await updateProfileAPI(profileData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to update profile'
      );
    }
  }
);

// ✅ Thunk for change password
export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (passwordData, { rejectWithValue }) => {
    try {
      const response = await changePasswordAPI(passwordData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to change password'
      );
    }
  }
);

// ✅ Thunk for refresh token
export const refreshToken = createAsyncThunk(
  'auth/refreshToken',
  async (_, { rejectWithValue }) => {
    try {
      const response = await refreshTokenAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to refresh token'
      );
    }
  }
);


// src/redux/auth/authSlice.js

export const fetchRoleListing = createAsyncThunk(
  'auth/getRoleList',
  async (params = {}, { rejectWithValue }) => { // Accept params here
    try {
      const response = await getRoleListAPI(params); // Pass straight to API
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch role list'
      );
    }
  }
);

// ... (rest of the file remains the same)

// ✅ Initial state
const initialState = {
  user: { data: null, loading: false, error: null },
  login: { data: null, loading: false, error: null },
  register: { data: null, loading: false, error: null },
  logout: { data: null, loading: false, error: null },
  forgotPassword: { data: null, loading: false, error: null },
  resetPassword: { data: null, loading: false, error: null },
  verifyEmail: { data: null, loading: false, error: null },
  updateProfile: { data: null, loading: false, error: null },
  changePassword: { data: null, loading: false, error: null },
  refreshToken: { data: null, loading: false, error: null },
  roleList: { data: null, loading: false, error: null }, // ✅ Added new state
  isAuthenticated: false,
  token: null
};

// ✅ Slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearLogin: (state) => {
      state.login.data = null;
      state.login.error = null;
    },
    clearRegister: (state) => {
      state.register.data = null;
      state.register.error = null;
    },
    clearLogout: (state) => {
      state.logout.data = null;
      state.logout.error = null;
    },
    clearForgotPassword: (state) => {
      state.forgotPassword.data = null;
      state.forgotPassword.error = null;
    },
    clearResetPassword: (state) => {
      state.resetPassword.data = null;
      state.resetPassword.error = null;
    },
    clearVerifyEmail: (state) => {
      state.verifyEmail.data = null;
      state.verifyEmail.error = null;
    },
    clearUpdateProfile: (state) => {
      state.updateProfile.data = null;
      state.updateProfile.error = null;
    },
    clearChangePassword: (state) => {
      state.changePassword.data = null;
      state.changePassword.error = null;
    },
    clearRefreshToken: (state) => {
      state.refreshToken.data = null;
      state.refreshToken.error = null;
    },
    clearRoleList: (state) => {
      state.roleList.data = null;
      state.roleList.error = null;
    },
    setAuthData: (state, action) => {
      state.user.data = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    clearAuthData: (state) => {
      state.user.data = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    clearAllAuthData: (state) => {
      state.user = { data: null, loading: false, error: null };
      state.login = { data: null, loading: false, error: null };
      state.register = { data: null, loading: false, error: null };
      state.logout = { data: null, loading: false, error: null };
      state.forgotPassword = { data: null, loading: false, error: null };
      state.resetPassword = { data: null, loading: false, error: null };
      state.verifyEmail = { data: null, loading: false, error: null };
      state.updateProfile = { data: null, loading: false, error: null };
      state.changePassword = { data: null, loading: false, error: null };
      state.refreshToken = { data: null, loading: false, error: null };
      state.roleList = { data: null, loading: false, error: null };
      state.isAuthenticated = false;
      state.token = null;
    }
  },
  extraReducers: (builder) => {
    // ✅ login
    builder
      .addCase(login.pending, (state) => {
        state.login.loading = true;
        state.login.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        console.log("Redux login.fulfilled - action.payload:", action.payload);
        state.login.loading = false;
        state.login.data = action.payload;
        state.user.data = action.payload;
        state.token = action.payload.token;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.login.loading = false;
        state.login.error = action.payload;
      });

    // ✅ register
    builder
      .addCase(register.pending, (state) => {
        state.register.loading = true;
        state.register.error = null;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.register.loading = false;
        state.register.data = action.payload;
      })
      .addCase(register.rejected, (state, action) => {
        state.register.loading = false;
        state.register.error = action.payload;
      });

    // ✅ logout
    builder
      .addCase(logout.pending, (state) => {
        state.logout.loading = true;
        state.logout.error = null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        state.logout.loading = false;
        state.logout.data = action.payload;
        state.user.data = null;
        state.token = null;
        state.isAuthenticated = false;
      })
      .addCase(logout.rejected, (state, action) => {
        state.logout.loading = false;
        state.logout.error = action.payload;
      });

    // ✅ forgot password
    builder
      .addCase(forgotPassword.pending, (state) => {
        state.forgotPassword.loading = true;
        state.forgotPassword.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.forgotPassword.loading = false;
        state.forgotPassword.data = action.payload;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.forgotPassword.loading = false;
        state.forgotPassword.error = action.payload;
      });

    // ✅ reset password
    builder
      .addCase(resetPassword.pending, (state) => {
        state.resetPassword.loading = true;
        state.resetPassword.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPassword.loading = false;
        state.resetPassword.data = action.payload;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetPassword.loading = false;
        state.resetPassword.error = action.payload;
      });

    // ✅ verify email
    builder
      .addCase(verifyEmail.pending, (state) => {
        state.verifyEmail.loading = true;
        state.verifyEmail.error = null;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.verifyEmail.loading = false;
        state.verifyEmail.data = action.payload;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.verifyEmail.loading = false;
        state.verifyEmail.error = action.payload;
      });

    // ✅ update profile
    builder
      .addCase(updateProfile.pending, (state) => {
        state.updateProfile.loading = true;
        state.updateProfile.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.updateProfile.loading = false;
        state.updateProfile.data = action.payload;
        state.user.data = action.payload.user || action.payload;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.updateProfile.loading = false;
        state.updateProfile.error = action.payload;
      });

    // ✅ change password
    builder
      .addCase(changePassword.pending, (state) => {
        state.changePassword.loading = true;
        state.changePassword.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.changePassword.loading = false;
        state.changePassword.data = action.payload;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.changePassword.loading = false;
        state.changePassword.error = action.payload;
      });

    // ✅ refresh token
    builder
      .addCase(refreshToken.pending, (state) => {
        state.refreshToken.loading = true;
        state.refreshToken.error = null;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.refreshToken.loading = false;
        state.refreshToken.data = action.payload;
        state.token = action.payload.token;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.refreshToken.loading = false;
        state.refreshToken.error = action.payload;
      });

    // ✅ get role list
    builder
      .addCase(fetchRoleListing.pending, (state) => {
        state.roleList.loading = true;
        state.roleList.error = null;
      })
      .addCase(fetchRoleListing.fulfilled, (state, action) => {
        state.roleList.loading = false;
        state.roleList.data = action.payload;
      })
      .addCase(fetchRoleListing.rejected, (state, action) => {
        state.roleList.loading = false;
        state.roleList.error = action.payload;
      });
  }
});

export const {
  clearLogin,
  clearRegister,
  clearLogout,
  clearForgotPassword,
  clearResetPassword,
  clearVerifyEmail,
  clearUpdateProfile,
  clearChangePassword,
  clearRefreshToken,
  clearRoleList, // ✅ new
  setAuthData,
  clearAuthData,
  clearAllAuthData
} = authSlice.actions;

export default authSlice.reducer;
